var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('popup', {
    attrs: {
      "opened": _vm.dataToShow,
      "width": "lg:w-11/12 sm:w-full"
    },
    on: {
      "close": _vm.close
    }
  }, [_c('div', {
    staticClass: "transform origin-top-left",
    class: {
      'scale-40 md:scale-75 lg:scale-100 mt-15 md:mt-0 md:ml-1/10 lg:ml-0': _vm.isPortraitOrientation,
      'scale-30 md:scale-35 lg:scale-75 mt-15 md:mt-0 -ml-4  md:ml-1/4 lg:ml-0': !_vm.isPortraitOrientation
    }
  }, [_c('div', {
    staticClass: "my-5 mx-5 lg:my-15 lg:mx-10 2xl:my-20 2xl:mx-15"
  }, [_c('vue-html2pdf', {
    ref: "cvPdf",
    staticClass: "bg-white w-max border-2 border-gray-600",
    attrs: {
      "show-layout": false,
      "float-layout": false,
      "enable-download": true,
      "preview-modal": false,
      "filename": "cv.pdf",
      "pdf-quality": 2,
      "manual-pagination": true,
      "pdf-format": "a4",
      "pdf-content-width": !_vm.isPortraitOrientation ? '1122px' : '800px',
      "html-to-pdf-options": {
        enableLinks: true,
        filename: 'CV ',
        jsPDF: {
          orientation: _vm.isPortraitOrientation ? 'portrait' : 'landscape',
          format: 'a4'
        },
        html2canvas: {
          scale: 2
        }
      }
    },
    on: {
      "progress": function ($event) {
        return _vm.onProgress($event);
      },
      "hasStartedGeneration": function ($event) {
        return _vm.hasStartedGeneration();
      },
      "hasGenerated": function ($event) {
        return _vm.hasGenerated($event);
      }
    }
  }, [_c('section', {
    attrs: {
      "slot": "pdf-content"
    },
    slot: "pdf-content"
  }, [_c('section', {
    staticClass: "pdf-item"
  }, [_c('model-pdf', {
    attrs: {
      "model-name": (((_vm.cvToPreview || {}).data || {}).shaping || {}).name,
      "model-color": (((_vm.cvToPreview || {}).data || {}).shaping || {}).color,
      "form": _vm.cvToPreview
    }
  })], 1)])])], 1)])]);

}
var staticRenderFns = []

export { render, staticRenderFns }